<nav class="fixed top-0 left-0 right-0 z-[100] transition-all duration-500 h-20"
     [class.bg-white/80]="!isMobileMenuOpen"
     [class.backdrop-blur-md]="!isMobileMenuOpen"
     [class.border-b]="!isMobileMenuOpen"
     [class.border-[#E5E0D5]/50]="!isMobileMenuOpen"
     [class.bg-[#F7F5F2]]="isMobileMenuOpen">
    
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between relative z-[110]">
        
        <!-- Logo & Brand -->
        <a routerLink="/home" (click)="closeMobileMenu()" class="flex items-center gap-4 group">
            <img src="FINAL.png" alt="Aarvya Logo" class="h-10 md:h-16 w-auto object-contain group-hover:scale-105 transition-all duration-500">
        </a>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center gap-10">
            <a routerLink="/home" routerLinkActive="nav-active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">Apothecary</a>
            <a routerLink="/faq" routerLinkActive="nav-active" class="nav-link">Rituals</a>
            <a routerLink="/about-us" routerLinkActive="nav-active" class="nav-link">Our Story</a>
        </div>

        <!-- Action Icons -->
        <div class="flex items-center gap-2 sm:gap-4">
            
            <!-- Search Icon & Expanded Bar (Desktop) -->
            <div class="hidden md:flex items-center relative group">
                <div 
                    class="flex items-center bg-[#FDFBF7] border border-[#E5E0D5]/50 rounded-full transition-all duration-500 overflow-hidden"
                    [class.w-64]="isSearchOpen"
                    [class.px-4]="isSearchOpen"
                    [class.w-10]="!isSearchOpen"
                    [class.border-transparent]="!isSearchOpen"
                    [class.bg-transparent]="!isSearchOpen"
                >
                    <button (click)="toggleSearch()" class="p-2 text-[#7A6E69] hover:text-[#3A2A25] transition-colors flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </button>
                    <input 
                        *ngIf="isSearchOpen"
                        type="text" 
                        [(ngModel)]="searchQuery"
                        (keyup.enter)="onSearch()"
                        placeholder="Search botanical rituals..."
                        class="bg-transparent border-none outline-none text-xs font-serif text-[#3A2A25] w-full py-2 placeholder:text-[#7A6E69]/50"
                        autoFocus
                    >
                </div>
            </div>
            
            <!-- Wishlist -->
            <a routerLink="/wishlist" class="p-2 text-[#8B7355] hover:text-red-500 transition-all duration-300 relative group rounded-full hover:bg-[#FDFBF7] flex items-center">
                <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                    </svg>
                    <span 
                        *ngIf="wishlist().length > 0"
                        class="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center animate-scale-up border border-white"
                    >
                        {{ wishlist().length }}
                    </span>
                </div>
            </a>
            <ng-container *ngIf="userProfile$ | async as profile; else loginLink">
                <div class="relative group hidden sm:block">
                    <button class="flex items-center gap-3 p-1.5 hover:bg-[#FDFBF7] rounded-full transition-all duration-300 border border-transparent hover:border-[#E5E0D5]/30">
                        <div class="w-9 h-9 rounded-full bg-[#3A2A25] text-white flex items-center justify-center text-xs font-serif shadow-md border-2 border-white">
                            {{ getInitials(profile.displayName) }}
                        </div>
                        <div class="hidden lg:block text-left">
                            <p class="text-[9px] uppercase tracking-widest text-[#8B7355] leading-none mb-0.5">Sanctuary of</p>
                            <p class="text-[11px] font-bold text-[#3A2A25] leading-none truncate max-w-[80px]">
                                {{ profile.displayName?.split(' ')?.at(0) }}
                            </p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 text-[#8B7355] group-hover:rotate-180 transition-transform duration-500">
                            <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                        </svg>
                    </button>
                    
                    <!-- Dropdown Menu -->
                    <div class="absolute right-0 top-full pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-500 transform translate-y-4 group-hover:translate-y-0 z-50">
                        <div class="w-64 glass-morphism rounded-sm p-1">
                            <div class="px-5 py-4 border-b border-[#E5E0D5]/30 mb-1">
                                <p class="text-[10px] text-[#8B7355] font-serif italic mb-1">Welcome back,</p>
                                <p class="text-sm font-bold text-[#3A2A25] truncate">{{ profile.displayName }}</p>
                            </div>
                            <div class="grid grid-cols-1">
                                <a routerLink="/profile" class="dropdown-link">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>
                                    <span>My Sanctuary</span>
                                </a>
                                <a *ngIf="profile.role === 'aarvya_admin'" routerLink="/admin/dashboard" class="dropdown-link text-[#A46A3F]">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
                                    <span class="font-bold">Admin Vault</span>
                                </a>
                                <div class="h-px bg-[#E5E0D5]/30 my-1 mx-4"></div>
                                <button (click)="logout()" class="dropdown-link text-red-700/80 w-full text-left">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/></svg>
                                    <span>Sign Out</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #loginLink>
                <button (click)="openSignInModal()" class="p-2 text-[#7A6E69] hover:text-[#3A2A25] transition-all duration-300 rounded-full group relative hidden sm:flex items-center justify-center hover:bg-[#F7F5F2]">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                    </svg>
                    <span class="absolute -bottom-6 left-1/2 -translate-x-1/2 text-[8px] uppercase tracking-[0.2em] font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 whitespace-nowrap">Entrance</span>
                </button>
            </ng-template>

            <!-- Shopping Cart -->
            <a routerLink="/cart" (click)="closeMobileMenu()" class="p-2 text-[#3A2A25] hover:text-[#A46A3F] transition-all duration-300 relative group rounded-full hover:bg-[#F7F5F2] flex items-center">
                <div class="relative">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                    </svg>
                    <span 
                        *ngIf="(cartItemCount$ | async) as count"
                        class="absolute -top-1 -right-1 bg-[#A46A3F] text-white text-[9px] font-bold rounded-full min-w-4 h-4 px-1 flex items-center justify-center animate-scale-up border border-white"
                    >
                        {{ count > 9 ? '9+' : count }}
                    </span>
                </div>
                <span class="hidden lg:inline text-[10px] uppercase tracking-[0.2em] font-medium text-[#7A6E69] group-hover:text-[#A46A3F] ml-2 transition-colors">Bag</span>
            </a>

            <!-- Mobile Menu Toggle -->
            <button 
                (click)="toggleMobileMenu()" 
                class="md:hidden p-2 text-[#3A2A25] transition-all duration-300 rounded-full hover:bg-[#E5DDD5]/20 relative z-[120]"
                aria-label="Toggle menu"
            >
                <div class="w-6 h-6 flex flex-col justify-center items-center gap-1.5 overflow-hidden">
                    <span class="w-6 h-0.5 bg-current transition-all duration-500 rounded-full"
                          [class.translate-y-[8px]]="isMobileMenuOpen"
                          [class.rotate-45]="isMobileMenuOpen"></span>
                    <span class="w-6 h-0.5 bg-current transition-all duration-500 rounded-full"
                          [class.opacity-0]="isMobileMenuOpen"
                          [class.-translate-x-full]="isMobileMenuOpen"></span>
                    <span class="w-6 h-0.5 bg-current transition-all duration-500 rounded-full"
                          [class.-translate-y-[8px]]="isMobileMenuOpen"
                          [class.-rotate-45]="isMobileMenuOpen"></span>
                </div>
            </button>
        </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <div 
        class="fixed inset-0 bg-[#F7F5F2] z-40 transition-all duration-500 ease-in-out md:hidden flex flex-col"
        [class.translate-x-full]="!isMobileMenuOpen"
        [class.translate-x-0]="isMobileMenuOpen"
        [class.opacity-0]="!isMobileMenuOpen"
        [class.opacity-100]="isMobileMenuOpen"
        [class.pointer-events-none]="!isMobileMenuOpen"
        [class.pointer-events-auto]="isMobileMenuOpen"
    >
        <!-- Botanical Decorations -->
        <div class="absolute -top-20 -left-20 w-64 h-64 opacity-10 pointer-events-none z-0 transform transition-all duration-1000 delay-300"
             [class.rotate-0]="isMobileMenuOpen"
             [class.-rotate-12]="!isMobileMenuOpen"
             [class.scale-100]="isMobileMenuOpen"
             [class.scale-90]="!isMobileMenuOpen">
            <img src="amla-top-left.jpg" alt="" class="w-full h-full object-contain mix-blend-multiply">
        </div>
        <div class="absolute -bottom-20 -right-20 w-80 h-80 opacity-10 pointer-events-none z-0 transform transition-all duration-1000 delay-300"
             [class.rotate-0]="isMobileMenuOpen"
             [class.rotate-12]="!isMobileMenuOpen"
             [class.scale-100]="isMobileMenuOpen"
             [class.scale-90]="!isMobileMenuOpen">
             <img src="amla-bottom-right.png" alt="" class="w-full h-full object-contain mix-blend-multiply">
        </div>

        <div class="relative z-10 flex-1 flex flex-col px-8 pt-24 pb-12 overflow-y-auto custom-scrollbar">
            <!-- Search (Mobile) -->
            <div class="mb-8 transition-all duration-500"
                 [style.transitionDelay]="isMobileMenuOpen ? '350ms' : '0ms'"
                 [class.opacity-100]="isMobileMenuOpen"
                 [class.translate-y-0]="isMobileMenuOpen"
                 [class.opacity-0]="!isMobileMenuOpen"
                 [class.translate-y-4]="!isMobileMenuOpen">
                <div class="relative">
                    <input 
                        type="text" 
                        [(ngModel)]="searchQuery"
                        (keyup.enter)="onSearch()"
                        placeholder="Search rituals..."
                        class="w-full bg-white border border-[#E5DDD5] rounded-sm py-4 pl-12 pr-4 text-sm font-serif outline-none focus:border-[#A46A3F] transition-all shadow-sm"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-[#8B7355]">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                </div>
            </div>

            <!-- Navigation Links -->
            <nav class="flex flex-col gap-2 mb-12">
                <a routerLink="/home" routerLinkActive="text-[#A46A3F] !border-[#A46A3F]" [routerLinkActiveOptions]="{exact: true}" (click)="closeMobileMenu()" 
                   class="mobile-nav-link" [style.transitionDelay]="isMobileMenuOpen ? '200ms' : '0ms'">
                   Apothecary
                </a>
                <a routerLink="/faq" routerLinkActive="text-[#A46A3F] !border-[#A46A3F]" (click)="closeMobileMenu()" 
                   class="mobile-nav-link" [style.transitionDelay]="isMobileMenuOpen ? '300ms' : '0ms'">
                   Rituals
                </a>
                <a routerLink="/about-us" routerLinkActive="text-[#A46A3F] !border-[#A46A3F]" (click)="closeMobileMenu()" 
                   class="mobile-nav-link" [style.transitionDelay]="isMobileMenuOpen ? '400ms' : '0ms'">
                   Our Story
                </a>
            </nav>

            <!-- User Status / Auth -->
            <div class="mt-auto space-y-8" [style.transitionDelay]="isMobileMenuOpen ? '500ms' : '0ms'" 
                 [class.opacity-100]="isMobileMenuOpen" [class.translate-y-0]="isMobileMenuOpen"
                 [class.opacity-0]="!isMobileMenuOpen" [class.translate-y-4]="!isMobileMenuOpen">
                
                <div *ngIf="userProfile$ | async as profile; else mobileLogin" class="space-y-6">
                    <div class="flex items-center gap-5 p-6 bg-white border border-[#E5E0D5]/40 rounded-sm shadow-[0_4px_20px_rgba(44,74,59,0.04)]">
                        <div class="w-16 h-16 rounded-full bg-[#3A2A25] text-white flex items-center justify-center text-2xl font-serif shadow-inner border-4 border-[#F7F5F2]">
                            {{ getInitials(profile.displayName) }}
                        </div>
                        <div class="min-w-0">
                            <p class="text-[10px] uppercase tracking-[0.3em] text-[#8B7355] font-serif italic mb-1">Sanctuary of</p>
                            <p class="text-xl font-bold text-[#3A2A25] truncate leading-tight">{{ profile.displayName }}</p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4">
                        <a routerLink="/profile" (click)="closeMobileMenu()" class="flex items-center justify-center w-full py-4 bg-[#3A2A25] text-white font-serif uppercase tracking-[0.25em] text-xs rounded-sm shadow-lg hover:bg-[#2C1F1A] transition-all">
                            Entrance to My Sanctuary
                        </a>
                        <a *ngIf="profile.role === 'aarvya_admin'" routerLink="/admin/dashboard" (click)="closeMobileMenu()" 
                           class="flex items-center justify-center w-full py-4 border border-[#A46A3F] text-[#A46A3F] font-serif uppercase tracking-[0.25em] text-xs rounded-sm">
                            Admin Vault
                        </a>
                        <button (click)="logout()" class="w-full py-3 text-red-800/70 text-[10px] uppercase tracking-[0.4em] font-bold">
                            End Ritual (Sign Out)
                        </button>
                    </div>
                </div>

                <ng-template #mobileLogin>
                    <div class="space-y-5">
                        <p class="text-center text-[#8B7355] font-serif italic text-sm mb-2">Begin your botanical journey</p>
                        <button (click)="openSignInModal()" class="block w-full py-5 text-center bg-[#3A2A25] text-white font-serif uppercase tracking-[0.3em] rounded-sm shadow-xl text-xs hover:bg-[#2C1F1A] transition-all">
                            Sign In
                        </button>
                        <button (click)="openSignUpModal()" class="block w-full py-5 text-center border-2 border-[#3A2A25] text-[#3A2A25] font-serif uppercase tracking-[0.3em] rounded-sm text-xs hover:bg-[#F7F5F2] transition-all">
                            Create Account
                        </button>
                    </div>
                </ng-template>
            </div>

            <!-- Brand Footer -->
            <div class="pt-16 pb-8 text-center mt-auto" [style.transitionDelay]="isMobileMenuOpen ? '600ms' : '0ms'"
                 [class.opacity-100]="isMobileMenuOpen" [class.translate-y-0]="isMobileMenuOpen"
                 [class.opacity-0]="!isMobileMenuOpen" [class.translate-y-4]="!isMobileMenuOpen">
                <p class="text-[9px] uppercase tracking-[0.5em] text-[#8B7355] mb-4 opacity-50 font-medium">AARVYA BOTANICALS</p>
                <div class="w-12 h-px bg-gradient-to-r from-transparent via-[#A46A3F] to-transparent mx-auto"></div>
            </div>
        </div>
    </div>
</nav>
